import {
  AUTH_TOKEN_HEADER_NAME,
  USER_EMAIL_HEADER_NAME,
} from 'src/app/project/shared/constants/auth.constants';
import { logErrorInSentry } from 'src/app/project/modules/errors/response-error';
import { getUserAuth } from '../http/user-auth';
import { getFeatureFlag } from '../services/feature-flag-helpers';
import { EFeatureFlag } from '../services/feature-flags-consts';

export function authorizeXMLHttpRequest(
  request: XMLHttpRequest,
  disableCaching?: boolean,
): XMLHttpRequest {
  const userAuth = getUserAuth();

  if (userAuth?.email && userAuth?.token) {
    request.setRequestHeader(AUTH_TOKEN_HEADER_NAME, userAuth.token);
    request.setRequestHeader(USER_EMAIL_HEADER_NAME, userAuth.email);

    if (disableCaching) {
      request.setRequestHeader('ngsw-bypass', 'true');
    }
  }

  return request;
}

interface XMLHttpRequestURL extends XMLHttpRequest {
  _url?: string | URL;
}

export function forceAuthHeadersOnXMLHttpRequests(): void {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (this: XMLHttpRequestURL, ...args: any[]): void {
    if (getFeatureFlag(EFeatureFlag.GA_NOT_APPEARING_BUG)) {
      try {
        this._url = args[1]?.toString();

        this.addEventListener('loadend', () => {
          const urlString = this._url?.toString() || '';
          const isTargetDomain = urlString.includes('pinpointworks.com');
          const isApiCall = urlString.includes('/api');

          if (this.status >= 400 && isTargetDomain && isApiCall) {
            console.error('XMLHttpRequest HTTP error:', this.status, this._url);
            logErrorInSentry({
              message: `XMLHttpRequest HTTP error ${this.status}: ${this._url}`,
              status: this.status,
            });
          }
        });

        return originalOpen.apply(this, args as unknown);
      } catch (error) {
        console.error('Error in XMLHttpRequest.open override:', error);
        logErrorInSentry({ message: `XMLHttpRequest.open error: ${error}`, error });
        throw error;
      }
    } else {
      this._url = args[1]?.toString();
      return originalOpen.apply(this, args as unknown);
    }
  };

  XMLHttpRequest.prototype.send = function (
    this: XMLHttpRequestURL,
    body?: Document | XMLHttpRequestBodyInit | null,
  ): void {
    if (getFeatureFlag(EFeatureFlag.GA_NOT_APPEARING_BUG)) {
      try {
        const urlString = this._url?.toString() || '';

        const isTargetDomain = urlString.includes('pinpointworks.com');
        const isApiCall = urlString.includes('/api');
        if (isTargetDomain && isApiCall) {
          authorizeXMLHttpRequest(this);
        }

        return originalSend.apply(this, [body] as unknown);
      } catch (error) {
        console.error('Error in XMLHttpRequest.send override:', error);
        logErrorInSentry({ message: `XMLHttpRequest.send error: ${error}`, error });
        throw error;
      }
    } else {
      const urlString = this._url?.toString() || '';

      const isTargetDomain = urlString.includes('pinpointworks.com');
      const isApiCall = urlString.includes('/api');
      if (isTargetDomain && isApiCall) {
        authorizeXMLHttpRequest(this);
      }

      return originalSend.apply(this, [body] as unknown);
    }
  };
}
